import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import '../../../styles/table.css'

import MaterialReactTable, { MRT_ColumnDef } from 'material-react-table'
import { useGetModuleResources } from 'utils/module'
import { CourseModel } from 'api/data-contracts'
import { darken } from '@mui/material'
import { RowSelection } from 'utils/models/Resource'
import AnchorLink from 'components/AnchorLink'

type Props = {
  setModuleRowSelection: React.Dispatch<React.SetStateAction<RowSelection>>
  moduleRowSelection: RowSelection
}

const ModuleResourcesTable = ({
  moduleRowSelection: rowSelection,
  setModuleRowSelection: setRowSelection,
}: Props) => {
  //defines the whole return of useQuery
  const { resources, isError } = useGetModuleResources()
  const { courseId } = useParams()

  const columns = useMemo<MRT_ColumnDef<CourseModel>[]>(
    () => [
      {
        accessorKey: 'name',
        header: 'Name',
        Cell: ({ cell }) => (
          <AnchorLink
            to={`/settings/course-setup/resources/${courseId}/resource/${cell?.row?.original?.id}`}
          >
            {cell?.row?.original?.name}
          </AnchorLink>
        ),
      },
      {
        accessorKey: 'description',
        header: 'Description',
      },
    ],
    [courseId],
  )

  if (isError) {
    return <span>Error loading resources</span>
  }

  if (typeof resources === 'undefined') {
    return <div>No resources found</div>
  }

  return (
    <MaterialReactTable
      columns={columns}
      data={resources}
      initialState={{
        showGlobalFilter: true,
      }}
      enableGlobalFilterModes
      muiSearchTextFieldProps={{
        placeholder: `Search`,
        sx: { maxWidth: '200px' },
        variant: 'outlined',
      }}
      muiTablePaperProps={{
        elevation: 0,
        sx: {
          borderRadius: '0',
          border: 'none',
        },
      }}
      muiTableBodyProps={{
        sx: theme => ({
          '& tr:nth-of-type(odd)': {
            backgroundColor: darken(theme.palette.background.default, 0.1),
          },
        }),
      }}
      muiTableBodyCellProps={{
        sx: {
          lineHeight: '1.6', //add a border between columns
        },
      }}
      enableRowSelection
      enableSelectAll={false}
      enableMultiRowSelection={true}
      getRowId={originalRow => originalRow.id || ''}
      onRowSelectionChange={setRowSelection}
      state={{
        rowSelection,
        showAlertBanner: isError,
        showProgressBars: false,
      }} //pass our managed row selection state to the table to use
      positionToolbarAlertBanner={'none'}
      enableColumnActions={false}
      enableColumnFilters={false}
      enablePagination={true}
      enableSorting={true}
      enableBottomToolbar={true}
      enableTopToolbar={true}
      enableToolbarInternalActions={false}
      muiTableBodyRowProps={{ hover: false }}
    />
  )
}

export { ModuleResourcesTable }
